import { render, staticRenderFns } from "./MandateOtpConfirmModal.vue?vue&type=template&id=120860b3&scoped=true&"
import script from "./MandateOtpConfirmModal.vue?vue&type=script&lang=js&"
export * from "./MandateOtpConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./MandateOtpConfirmModal.vue?vue&type=style&index=0&id=120860b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120860b3",
  null
  
)

export default component.exports